"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Setting/VoicePermissionDeniedContent";

import NextImage from "../NextImage";
import React from "react";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

export interface VoicePermissionDeniedContentProps {
  onOpenSettings: () => void;
  onCancel: () => void;
  className?: string;
}

const ICON_SRC = "/assets/images/voice-permission-mic-icon.svg";

export const VoicePermissionDeniedContent: React.FC<
  VoicePermissionDeniedContentProps
> = ({ onOpenSettings, onCancel, className }) => {
  return (
    <div className={cn("flex w-full flex-col items-center gap-6", className)}>
      <div className="flex w-full flex-col items-center gap-4">
        <div className="flex size-16 items-center justify-center rounded-full">
          <NextImage
            src={ICON_SRC}
            alt=""
            width={64}
            height={64}
            className="size-16 object-contain"
          />
        </div>
        <h2 className="headline_regular_s text-content_primary text-center">
          {I18n.t("Allow Access to the Microphone")}
        </h2>
        <p className="body_m text-content_secondary -mt-2 text-center">
          {I18n.t("Just speak to type and go completely hands-free")}
        </p>
      </div>
      <div className="flex w-full flex-col gap-2">
        <button
          type="button"
          className="button sm_button primary_button button_m flex h-11 w-full items-center justify-center rounded-2 text-content_inverse_primary"
          onClick={onOpenSettings}
        >
          {I18n.t("Open Settings")}
        </button>
        <button
          type="button"
          className="button sm_button button_m flex h-11 w-full items-center justify-center rounded-2 bg-transparent text-content_primary"
          onClick={onCancel}
        >
          {I18n.t("Cancel")}
        </button>
      </div>
    </div>
  );
};
